import { CheckCircle2, XCircle, PackageX, DollarSign, Repeat, CalendarCheck, Truck } from "lucide-react";

// Keep in sync with backend/models.py's RESPONSE_TYPES.
export const RESPONSE_TYPES = [
  { value: "acknowledged", label: "Acknowledged", icon: CheckCircle2, color: "text-emerald-600" },
  { value: "rejected", label: "Rejected", icon: XCircle, color: "text-red-600" },
  { value: "backordered", label: "Backordered", icon: PackageX, color: "text-amber-600" },
  { value: "price_changed", label: "Price Changed", icon: DollarSign, color: "text-amber-600" },
  { value: "substitution_proposed", label: "Substitution Proposed", icon: Repeat, color: "text-amber-600" },
  { value: "delivery_date_confirmed", label: "Delivery Date Confirmed", icon: CalendarCheck, color: "text-sky-600" },
  { value: "shipped", label: "Shipped", icon: Truck, color: "text-sky-600" },
];

export const responseTypeMeta = (v) => RESPONSE_TYPES.find((t) => t.value === v) || { label: v, icon: CheckCircle2, color: "text-slate-500" };
